export default __webpack_public_path__ + "static/media/phone-active.3da3ef40.svg";